import React, { useState, useRef } from 'react';
import { Row, Col, Card, Tooltip, OverlayTrigger, Modal, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// utils
import { handlerErrors } from 'utils/handleErrors';
import ModalAddress from './ModalAddress';
// components
import { ToastSuccess } from '../../../../components/alerts/toast';
import ButtonRequest from '../../../../components/buttons/ButtonRequest';
// reducer
import { setAddressesFrom } from '../../../../slices/generalData/generalData';
// API
import { deleteAddress, getAllAddressesToForm } from '../../../../api/Api-user';
import { useHandleResponse } from '../../../../hooks/useHandleResponse';

const CardAddress = ({ address, setTrigger }) => {
  const buttonRef = useRef(null);
  const dispatch = useDispatch();
  const { handleResponse } = useHandleResponse();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  // console.log('car address:', address);
  const handleClose = () => {
    setIsModalOpen(false);
    // Esperar un poco para que el modal cierre y luego quitar el foco
    setTimeout(() => {
      if (buttonRef.current) {
        buttonRef?.current.blur();
      }
    }, 500);
  };
  // update adrresses
  const updateAddressesFrom = async () => {
    try {
      // 1. Borrar el localStorage para forzar una nueva petición
      localStorage.removeItem('addressesFrom');

      // 2. Hacer la petición a la API
      const response = await getAllAddressesToForm('SEND');

      if (response?.address) {
        // 3. Guardar la nueva data en localStorage
        localStorage.setItem('addressesFrom', JSON.stringify(response.address));

        // 4. Actualizar el estado global
        dispatch(setAddressesFrom({ data: response.address }));
      }
    } catch (error) {
      console.error('Error al obtener direcciones:', error);
    }
  };
  // update adrresses
  const updateAddressesTo = async () => {
    try {
      // 1. Borrar el localStorage para forzar una nueva petición
      localStorage.removeItem('addressesTo');

      // 2. Hacer la petición a la API
      const response = await getAllAddressesToForm('RECEIVE');

      if (response?.address) {
        // 3. Guardar la nueva data en localStorage
        localStorage.setItem('addressesTo', JSON.stringify(response.address));

        // 4. Actualizar el estado global
        dispatch(setAddressesFrom({ data: response.address }));
      }
    } catch (error) {
      console.error('Error al obtener direcciones:', error);
    }
  };
  const deleteAddressHandler = async () => {
    try {
      setIsButtonDisabled(true);
      const response = await deleteAddress(address.id);
      // console.log('se elimino direccion, refresh page', response);
      setIsModalDeleteOpen(false);
      setIsModalOpen(false);
      handleResponse(response, (res) => {
        if (res?.data.is_deleted) {
          // response just with that is_delete : true
          setIsModalOpen(false);
          ToastSuccess('✨¡La dirección fue removida de tu lista.');
          setTrigger((prev) => !prev);
          updateAddressesTo();
          updateAddressesFrom();
        }
      });
    } catch (error) {
      handlerErrors(error);
    } finally {
      setIsButtonDisabled(false);
    }
  };

  return (
    <>
      {/* Delete modal start */}
      <Modal show={isModalDeleteOpen} onHide={() => setIsModalDeleteOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="text-primary" />
        </Modal.Header>
        <Modal.Body className="bg-infow">
          <div className="text-semi-large mb-4 text-primary">{address?.name.toUpperCase()}</div>
          <div className="text-semi-large mb-3">¿Estas segur@ de que deseas elimimar esta dirección?</div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end ">
            <Button variant="outline-primary" className="me-2" onClick={() => setIsModalDeleteOpen(false)}>
              Cancelar
            </Button>
            <ButtonRequest
              title="Si, Eliminar"
              titleLoading="Eliminando"
              handlerFn={deleteAddressHandler}
              isButtonDisabled={isButtonDisabled}
              isLoading={isButtonDisabled}
            />
          </div>
        </Modal.Footer>
      </Modal>
      {/* Delete modal end */}
      {/* Detail modal start */}
      <ModalAddress addressDetail={address} isModalOpen={isModalOpen} setIsModalDeleteOpen={setIsModalDeleteOpen} handleClose={handleClose} />
      {/* Detail modal end */}
      <Card className="mb-2">
        <Card.Body className="py-3 py-lg-0 sh-auto sh-lg-11 sh-xl-9">
          <Row className="g-0 h-100 align-content-center">
            <Col
              xs="12"
              sm="9"
              lg="3"
              className="mb-2 mb-lg-0 pe-lg-4 d-flex flex-column justify-content-center order-1 order-lg-1 h-lg-100 position-relative bg-secondaryx"
            >
              <div className="text-muted text-small d-lg-none">Nombre</div>
              <OverlayTrigger
                delay={{ show: 500, hide: 0 }}
                placement="top"
                overlay={<Tooltip id="tooltip-top">Haz clic para ver detalle de dirección</Tooltip>}
              >
                <button
                  ref={buttonRef}
                  type="button"
                  className="btn-open-addresses-modal text-primary text-start"
                  // Width with medias  maxWidth: '200px'
                  // style={{ backgroundColor: 'transparent', borderStyle: 'none', overflowX: 'scroll', maxWidth: '100%' }}
                  onClick={() => setIsModalOpen(true)}
                >
                  {address.name.toUpperCase()}
                </button>
              </OverlayTrigger>
            </Col>
            <Col xs="12" lg="4" className="mb-3 mb-lg-0 pe-lg-4 d-flex flex-column justify-content-center order-3 order-lg-3 bg-secondaryx">
              <div className="text-muted text-small d-lg-none">Calle</div>
              {address.street.toUpperCase()}
            </Col>
            <Col
              xs="6"
              sm="3"
              lg="2"
              className="d-lg-none d-flex flex-column justify-content-center align-items-start align-items-lg-center mb-2 mb-lg-0 order-4 order-lg-4 bg-successx"
            >
              <div className="text-muted text-small d-lg-none">Número</div>
              <div className="text-alternate pe-4"> {address.street_number}</div>
            </Col>
            <Col xs="9" lg="3" className="d-flex flex-column justify-content-center mb-2 mb-lg-0 order-5 order-lg-4 bg-infox">
              <div className="text-muted text-small d-lg-none">Colonia</div>
              <div className="text-alternate pe-2 ">{address.neighborhood.toUpperCase()}</div>
            </Col>
            <Col
              xs="12"
              lg="1"
              className="d-flex flex-column justify-content-center align-items-end align-items-lg-center mb-2 mb-lg-0 order-5 order-lg-5 bg-secondaryx"
            >
              <div className="text-muted text-small d-lg-none mb-1">C.P</div>
              <div className="text-alternate">{address.zip_code}</div>
            </Col>
            <Col xs="12" sm="3" lg="1" className="d-flex justify-content-end align-items-center my-2  my-lg-0 order-2 order-lg-5 bg-warningx">
              <OverlayTrigger delay={{ show: 300, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
                <div className="d-flex flex-column align-items-center justify-content-center me-3">
                  <div className="text-muted text-small d-lg-none">Editar </div>
                  <NavLink className="cursor-pointer" to={`/configuración/direcciones/editar/${address.id}`}>
                    <CsLineIcons icon="edit" size="18" className="btn-link" />
                  </NavLink>
                </div>
              </OverlayTrigger>
              <OverlayTrigger delay={{ show: 300, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
                <div className="d-flex flex-column align-items-end justify-content-center">
                  <div className="text-muted text-small d-lg-none">Eliminar</div>
                  <span className="cursor-pointer" onClick={() => setIsModalDeleteOpen(true)}>
                    <CsLineIcons icon="bin" size="18" className="btn-link" />
                  </span>
                </div>
              </OverlayTrigger>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};
export default CardAddress;
